/**
 * 管理后台入口
 * - Pinia（状态）
 * - Vue Router（路由 + 守卫）
 * - Element Plus（UI 库）
 * - design-tokens（@yindu/shared/dist/tokens-admin.css 全局变量）
 */
import { createPinia } from 'pinia'
import { createApp } from 'vue'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'

import App from './App.vue'
import { router } from './router'
import '@yindu/shared/tokens-admin.css'
import './styles/main.scss'

const app = createApp(App)
app.use(createPinia())
app.use(router)
app.use(ElementPlus)
app.mount('#app')
